import * as React from 'react';

export default function x() {
  return (
    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
      <path d="M0,0 L15,15"/>
      <path d="M0,15 L15,0"/>
    </svg>
  );
}
